export var colorMap = {
  info: {
    background: 'blue.base',
    heading: 'base.white',
    paragraph: 'base.white',
    icon: 'base.white',
    button: 'base.white'
  },
  success: {
    background: 'green.base',
    heading: 'base.white',
    paragraph: 'base.white',
    icon: 'base.white',
    button: 'base.white'
  },
  warning: {
    background: 'yellow.dark',
    heading: 'base.white',
    paragraph: 'base.white',
    icon: 'base.white',
    button: 'base.white'
  },
  neutral: {
    background: 'green.darker',
    heading: 'base.white',
    paragraph: 'base.white',
    icon: 'base.white',
    button: 'base.white'
  },
  generic: {
    background: 'base.white',
    heading: 'text.base',
    paragraph: 'text.base',
    icon: 'grey.dark',
    button: 'base.black'
  },
  error: {
    background: 'red.base',
    heading: 'base.white',
    paragraph: 'base.white',
    icon: 'base.white',
    button: 'base.white'
  }
};
export var invertedColorMap = {
  info: {
    background: 'blue.lighter',
    heading: 'blue.darker',
    paragraph: 'blue.dark',
    icon: 'blue.base',
    button: 'base.black'
  },
  success: {
    background: 'green.lighter',
    heading: 'green.darker',
    paragraph: 'green.dark',
    icon: 'green.base',
    button: 'base.black'
  },
  warning: {
    background: 'yellow.lighter',
    heading: 'yellow.darker',
    paragraph: 'yellow.darker',
    icon: 'yellow.dark',
    button: 'base.black'
  },
  neutral: {
    background: 'green.darker',
    heading: 'base.white',
    paragraph: 'base.white',
    icon: 'base.white',
    button: 'base.white'
  },
  generic: {
    background: 'grey.lighter',
    heading: 'text.base',
    paragraph: 'grey.dark',
    icon: 'grey.dark',
    button: 'base.black'
  },
  error: {
    background: 'red.lighter',
    heading: 'red.darker',
    paragraph: 'red.dark',
    icon: 'red.dark',
    button: 'base.black'
  }
};